<div class="icon" [style.width.px]="frame()" [style.height.px]="frame()">
  <onyx-custom-icon
    source="icons/{{ name() }}.svg"
    [size]="size()"
  ></onyx-custom-icon>
</div>
